import React, { useEffect, useState } from 'react'
import ContentLayout from '../../../components/layout-components/ContentLayout'
import { useSSR, useTranslation } from 'react-i18next';
import "./SummaryAgent.scss";
import { Box, Grid, Paper } from '@mui/material';
import { Typography } from 'antd';
import Chat from './components/Chat';
import AISummaryHistory from './components/AISummaryHistory';
import SelectedSummary from './components/SelectedSummary';
import TitleBar from "../../../components/layout-components/TitleBar";
import { getAllSummaryHistory } from '../../../services/AiService';


export default function SummaryAgent() {

    const { t, i18n } = useTranslation();
    const [isDateSelected, setIsDateSelected] = useState(false);
    const [isRefreshed, setRefreshed] = useState(false);
    const [reloadHistory, setReloadHistory] = useState(false);
    const [selectedSummaries, setSelectedSummaries] = useState([]);
    const [summaryHistory, setSummaryHistory] = useState({});
    const [generatedSummary, setGenerateSummary] = useState(undefined);

    useEffect(() => {
        if (isRefreshed) {
            setReloadHistory(!reloadHistory);
            setRefreshed(false);
        }
    }, [isRefreshed]);

    return (
        <div>
            <TitleBar
                id="header-text-member-name"
                title={t("RAL1208")}
                // actions={actions}
                isLoading={false}
                bg={"transparent"}
            ></TitleBar>

            <div className='summary-agent-container'  >
                <div className='summary-agent-component1'>
                    <Paper sx={{
                        width: '100%',
                        height: '100%',
                        p: 2,
                        overflowY: 'auto',
                    }}>
                        <Box width={'100%'}>
                            <Chat isRefreshed={isRefreshed} setRefreshed={setRefreshed} isDateSelected={isDateSelected} />
                            {isDateSelected && <SelectedSummary
                                setIsDateSelected={setIsDateSelected}
                                setSelectedSummaries={setSelectedSummaries}
                                selectedSummaries={selectedSummaries}
                            />}
                        </Box>
                    </Paper>
                </div>
                <div className='summary-agent-component2'>
                    <Paper sx={{
                        width: '100%',
                        height: '100%',
                        p: 2,
                        display: 'flex',
                        flexDirection: 'column',
                    }}>
                        <Typography className='cardTitle'>
                            {t('RAL1203')}
                        </Typography>
                        <Box sx={{
                            overflowY: 'auto',
                            mt: 1,
                        }}>
                            <AISummaryHistory
                                setIsDateSelected={setIsDateSelected}
                                setSelectedSummaries={setSelectedSummaries}
                                reloadHistory={reloadHistory} />
                        </Box>
                    </Paper>
                </div>
                {/* <CustomizedButtonDatePicker
                    ref={datePickerRef}
                    value={dateValue}
                    label="Select a Date"
                    onChange={(date) => {
                        
                    }}
                /> */}
            </div>
        </div>
    )
}
